// @vendors
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
const PropTypes = require('prop-types');
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import FeatureToggingRoute from 'hocs/featureToggingRoute/featureToggingRoute';

class NewFEFeatureFlagRender extends Component {
  render() {
    const { asisFeatureFlag, featureFlag, flagBasedFeatures, redirectTo, redirectFrom, OKComponent } = this.props;
    const AsisComponent = asisFeatureFlag ?
        <FeatureToggingRoute component={OKComponent} notAllowedProductKey={asisFeatureFlag} {...this.props} /> :
        <OKComponent {...this.props} />;
    return flagBasedFeatures.get(featureFlag) ? <Redirect to={redirectTo} from={redirectFrom}/> : AsisComponent;
  }
}

NewFEFeatureFlagRender.propTypes = {
  asisFeatureFlag: PropTypes.string,
  featureFlag: PropTypes.string.isRequired,
  flagBasedFeatures: PropTypes.object.isRequired,
  redirectTo: PropTypes.string.isRequired,
  redirectFrom: PropTypes.string.isRequired,
  OKComponent: PropTypes.element.isRequired,
};

export default withFeatureToggling(NewFEFeatureFlagRender);
